export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6851.ac6efe5c.jpg";